import _ from "lodash";

import { Box, Divider } from "@chakra-ui/react";

import FilterForm from "../../components/FilterForm";
import ArrivalRatesTable from "../../components/organization/ArrivalRatesTable";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  ARRIVAL_RATES_FREQUENCIES,
  LEVELS,
} from "../../store/constants";
import ArrivalHeatmap from "../../components/ArrivalHeatmap";
import ArrivalRatesLineGraph from "../../components/ArrivalRatesLineGraph";
import Loader from "../../components/loader";
import { getReportDescription } from "../../store/helpers";

const ArrivalRatesPerHour = ({ showFilterForm = true, reportIndex = 1 }) => {
  const { tickets, loading, reportRange } = useSelector(
    (state) => state.defaultReducer
  );
  const ticketsClone = _.cloneDeep(tickets);

  //Entire services
  const arrivalTimes = ticketsClone.map((entry) => dayjs.unix(entry.created));

  const arrivalTimesPerDay = arrivalTimes.reduce((acc, arrivalTime) => {
    const formattedDate = arrivalTime.format("YYYY-MM-DD");

    acc[formattedDate] = (acc[formattedDate] || 0) + 1;

    return acc;
  }, {});
  const title = `${reportIndex}. Arrival Rates Per Hour`;
  console.log(title);

  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <Box mb="20px">
                <h1>{title}</h1>
                <p>{getReportDescription(reportRange).ArrivalRatesPerHour}</p>
              </Box>
              <Box className="reportContainer" mt="20px">
                <ArrivalRatesTable
                  arrivalTimesPerDay={arrivalTimesPerDay}
                  frequency={ARRIVAL_RATES_FREQUENCIES.HOUR}
                  reportIndex={reportIndex}
                />
                <Box mt="20px" mb="20px">
                  <ArrivalRatesLineGraph
                    arrivalTimesPerDay={arrivalTimesPerDay}
                    frequency={ARRIVAL_RATES_FREQUENCIES.HOUR}
                    level={LEVELS.ORGANIZATION}
                    title={
                      "Entire Organization Arrival Rates, Day by Day Comparison"
                    }
                    height={"300px"}
                  />
                </Box>
              </Box>
              <Divider />
              <ArrivalHeatmap arrivalTimes={arrivalTimes} />
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default ArrivalRatesPerHour;
